'use strict';

const country = $('body').attr('data-layer-country');

module.exports = {
    pushPDPClickRXB2C: function () {
        dataLayer.push({
            event: 'Etape0',
            country: country
        });
    },
    pushPDPFilterPrescription: function (isFilterPrescriptionActive) {
        dataLayer.push({
            choixPrescription: isFilterPrescriptionActive ? 'Prescription' : 'Non prescription',
            event: 'OptionPrescription',
            country: country
        });
    },
    pushLensChange: function () {
        dataLayer.push({
            event: 'ChangementVerre',
            country: country
        });
    },
    pushPDMeasureMode: function (pdMode) {
        let datalayerChoixMesure = 'Saisir manuellement';
        if (pdMode === 'measure') {
            datalayerChoixMesure = 'Mesurer la DP en ligne';
        }
        dataLayer.push({
            choixMesure: datalayerChoixMesure,
            event: 'SaisiDP',
            country: country
        });
    },
    pushPDMeasureWidget: function () {
        dataLayer.push({
            event: 'MesurePupille',
            country: country
        });
    },
    pushClickNext: function (currentSection, $container) {
        if (currentSection === '2') {
            let lensType = $('.js-datalayer-lens-type.selected', $container).attr('data-layer-lens-type');
            dataLayer.push({
                event: 'Etape' + currentSection,
                prescriptionType: lensType,
                country: country
            });
        } else {
            dataLayer.push({
                event: 'Etape' + currentSection,
                country: country
            });
        }
    },
    pushClickPrev: function (currentSection) {
        dataLayer.push({
            etape: 'Etape' + currentSection,
            event: 'Retour',
            country: country
        });
    },
    pushClickStepper: function (currentSection, requestedStep) {
        dataLayer.push({
            etape: 'Etape' + currentSection,
            etapeSelectionnee: 'Etape' + requestedStep,
            event: 'RetourClicEtape',
            country: country
        });
    }
};
